ready(function(){

	// -- main menu (mobile) --
	const menusBtn = document.getElementById('menusBtn');
	
	// -- events handler --
	menusBtn.addEventListener('click', handleMainMenuClick);
	window.addEventListener('resize', handleWindowResize);

	// -- handle functions --
	function handleMainMenuClick(e) {
		document.body.classList.toggle('menu--open');
	}
	
	function handleWindowResize() {
		if (window.innerWidth > 768) {
		  document.body.classList.remove('menu--open');
		}
	}


	// -- artworks details : sticky menu --
	const sections = document.querySelectorAll("section");
	const navLinks = document.querySelectorAll(".quicklinksMenu a");
	window.onscroll = () => {
	  var current = "";

	  sections.forEach((section) => {
	    const sectionTop = section.offsetTop;
	    if (pageYOffset >= sectionTop - 88) {
	      current = section.getAttribute("id"); }
	  });

	  navLinks.forEach((link) => {
	    link.classList.remove("active");
	    if (link.getAttribute("href").substring(1) == current) {
	      link.classList.add("active");
	    }
	  });
	};

});